import { render, staticRenderFns } from "./LineaTiempoA.vue?vue&type=template&id=458e9511&lang=pug&"
import script from "./LineaTiempoA.vue?vue&type=script&lang=js&"
export * from "./LineaTiempoA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports